// extracted by mini-css-extract-plugin
export default {"layoutsContainer":"Layouts_layoutsContainer__tZE99","layoutOptionContainer":"Layouts_layoutOptionContainer__-RSC2","switch":"Layouts_switch__mgEOU"};